
//create notification//
export const CREATE_NOTIFICATION = "CREATE_NOTIFICATION";
export const CREATE_NOTIFICATION_SUCCESS = "CREATE_NOTIFICATION_SUCCESS";
export const CREATE_NOTIFICATION_FAIL = "CREATE_NOTIFICATION_FAIL";

export const CREATE_EDIT_NOTIFICATION_API_STATUS = "CREATE_EDIT_NOTIFICATION_API_STATUS";
export const CREATE_NOTIFICATION_DISABLE = "CREATE_NOTIFICATION_DISABLE";
export const NOTIFICATION_LOADER = "NOTIFICATION_LOADER";


// Get All Notifications
export const GET_ALL_NOTIFICATIONS = "GET_ALL_NOTIFICATIONS";
export const GET_ALL_NOTIFICATIONS_SUCCESS = "GET_ALL_NOTIFICATIONS_SUCCESS";
export const GET_ALL_NOTIFICATIONS_FAIL = "GET_ALL_NOTIFICATIONS_FAIL";

// For Getting Notification by Id
export const GET_NOTIFICATIONS_BY_ID = "GET_NOTIFICATIONS_BY_ID";
export const GET_NOTIFICATIONS_BY_ID_SUCCESS = "GET_NOTIFICATIONS_BY_ID_SUCCESS";
export const GET_NOTIFICATIONS_BY_ID_FAIL = "GET_NOTIFICATIONS_BY_ID_FAIL";

// For Cancle Notification by Id
export const CANCLE_NOTIFICATIONS_BY_ID = "CANCLE_NOTIFICATIONS_BY_ID";
export const CANCLE_NOTIFICATIONS_BY_ID_SUCCESS = "CANCLE_NOTIFICATIONS_BY_ID_SUCCESS";
export const CANCLE_NOTIFICATIONS_BY_ID_FAIL = "CANCLE_NOTIFICATIONS_BY_ID_FAIL";

// For Updating Notification Data
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
export const UPDATE_NOTIFICATION_SUCCESS = "UPDATE_NOTIFICATION_SUCCESS";
export const UPDATE_NOTIFICATION_FAIL = "UPDATE_NOTIFICATION_FAIL";

// For Searching Notification
export const SEARCH_NOTIFICATION = "SEARCH_NOTIFICATION";
export const SEARCH_NOTIFICATION_SUCCESS = "SEARCH_NOTIFICATION_SUCCESS";
export const SEARCH_NOTIFICATION_FAIL = "SEARCH_NOTIFICATION_FAIL";

// For Before Login Marquee
export const BEFORE_LOGIN_MARQUEE = "BEFORE_LOGIN_MARQUEE";
export const BEFORE_LOGIN_MARQUEE_SUCCESS = "BEFORE_LOGIN_MARQUEE_SUCCESS";
export const BEFORE_LOGIN_MARQUEE_FAIL = "BEFORE_LOGIN_MARQUEE_FAIL";
